"use strict";

/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlRegistrationParams = void 0;
/**
 * Data type for Control Registration Parameters
 */
var ControlRegistrationParams = /** @class */function () {
  /**
   * Create a new ControlRegistrationParams instance
   *
   * @param definition  the service definition
   * @param group  the control group
   */
  function ControlRegistrationParams(definition, group) {
    this.definition = definition;
    this.group = group;
  }
  return ControlRegistrationParams;
}();
exports.ControlRegistrationParams = ControlRegistrationParams;